import type { ExtendedAxiosError } from "@entrilia/shared/api/axiosHelper";
import { getApiError } from "@entrilia/shared/api/axiosHelper";
import { redirectToEmailVerification } from "../auth/authRedirects";

export const emailNotVerifiedErrorPipe = (axiosError: ExtendedAxiosError): Promise<never> | undefined => {
  if (axiosError.response?.status === 400 || axiosError.response?.status === 403) {
    const apiError = getApiError(axiosError);
    if (apiError.type === "EmailNotVerified") {
      redirectToEmailVerification();
    }
  }

  return undefined;
};
